import React, { ChangeEvent, useCallback, useState } from 'react';
import { Modal as DSModal, Button } from '@vtblife/uikit';
import { Textarea, RadioGroup } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { useReportMutation } from '../ReportMutation';
import { BanReasonEnum } from '../__generated__/ReportMutation.graphql';
import ReportButtonIconSuccess from '../../../../icons/SuccessGiveMeFiveCouplePeopleImage.url.svg';

import './styles.css';

const cn = classname.bind(null, 'ReportModal');

export function ReportModal({
    isMobile,
    handleCloseModal,
    offerId
}: {
    offerId: string;
    isMobile?: boolean;
    handleCloseModal: () => void;
}) {
    const staticPath = useStaticPathConfig();

    const [ errorMessage, setErrorMessage ] = useState('');
    const [ isSubmitted, setIsSubmitted ] = useState(false);
    const [ reportData, setReportData ] = useState({ type: undefined as BanReasonEnum | undefined, comment: '' });
    const reportMutation = useReportMutation();

    const setType = useCallback((value: BanReasonEnum, e: React.ChangeEvent<HTMLElement>) => {
        e?.preventDefault();
        setReportData(state => ({
            ...state,
            type: value
        }));
    }, []);

    const setComment = useCallback((value: string, event: ChangeEvent<Element>) => {
        event?.preventDefault();
        setReportData(state => ({
            ...state,
            comment: value
        }));
    }, []);

    const handleSendReport = useCallback((e?: React.MouseEvent<Element, MouseEvent>) => {
        e?.preventDefault();
        if (! reportData.type) return setErrorMessage('Что-то пошло не так');

        reportMutation({
            offerId,
            banReason: reportData.type,
            comment: reportData.comment
        })
            .then(() => {
                setIsSubmitted(true);
                setErrorMessage('');
            })
            .catch(err => {
                window.console.error(err);
                setErrorMessage('Что-то пошло не так');
            });
    }, [ reportData, reportMutation, offerId ]);

    const disabledButton = Boolean(! reportData.type || (reportData.type === 'UNKNOWN' && ! reportData.comment));
    const successContent = (
        <DSModal.Content>
            <p className={cn('successMessage', { isMobile })}>
                Мы всё проверим. Спасибо, что делаете наш сервис лучше!
            </p>
            <div className={cn('successIcon', { isMobile })}>
                <img
                    src={`${staticPath}${ReportButtonIconSuccess}`}
                    alt='картинка благодарности'
                    crossOrigin='anonymous'
                />
            </div>
        </DSModal.Content>
    );
    const content = (
        <DSModal.Content scrollable={isMobile}>
            <div className={cn('wrapper')}>
                <form className={cn('form')}>
                    <RadioGroup<BanReasonEnum>
                        className={cn('radioGroup')}
                        values={reportTypes}
                        value={reportData.type as BanReasonEnum}
                        onChange={setType}
                    />
                    {reportData.type && (
                        <Textarea
                            fullWidth
                            className={cn('reportMessage')}
                            value={reportData.comment}
                            onChange={setComment}
                            placeholder='Какая причина жалобы?'
                        />
                    )}
                </form>
                {errorMessage && <p className={cn('errorMessage')}>{errorMessage}</p>}
                <DSModal.Actions>
                    <Button
                        variant='primary'
                        type='button'
                        disabled={disabledButton}
                        onClick={handleSendReport}
                    >
                        Отправить жалобу
                    </Button>
                </DSModal.Actions>
            </div>
        </DSModal.Content>
    );

    return (
        <DSModal
            opened
            mobile={isMobile}
            swipeToClose={! isMobile}
            onClose={handleCloseModal}
            data-scroll-lock-ignore
        >
            {isMobile ? null : <DSModal.Title>Пожаловаться</DSModal.Title>}
            {isMobile ? <DSModal.Header>Пожаловаться</DSModal.Header> : null}
            <>{isSubmitted ? successContent : content}</>
        </DSModal>
    );
}

const reportTypes: { label: string; value: BanReasonEnum }[] = [
    {
        label: 'Уже продано',
        value: 'RELEVANCE_SOLD'
    },
    {
        label: 'Не дозвониться',
        value: 'RELEVANCE_NO_REPLY'
    },
    {
        label: 'Неверный номер',
        value: 'RELEVANCE_WRONG_NUMBER'
    },
    {
        label: 'Неверная цена',
        value: 'INCORRECT_PRICE'
    },
    {
        label: 'Неверный адрес',
        value: 'ADDRESS_OTHER'
    },
    {
        label: 'Проблемы с фото',
        value: 'PHOTOS_OTHER'
    },
    {
        label: 'Проблемы с описанием',
        value: 'DESCRIPTION_OTHER'
    },
    {
        label: 'Мошенничество или введение в заблуждение',
        value: 'SCAM_OTHER'
    },
    {
        label: 'Другое',
        value: 'UNKNOWN'
    }
];
